export enum JobFlagType {
  archived = 'Archived',
}
